import styled from 'styled-components'
import { ButtonMui } from 'src/components/ButtonMui'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: .8rem;
    padding: .4rem 1rem .4rem 1rem;
`
export const CustomButton = styled(ButtonMui)`
    width: 100%;    
    height: 2.8rem !important;
    margin: 0 !important;
`
